import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-6">
          {aboutContent.title}
        </h2>
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutContent.desc}
          </p>
          <div className="flex flex-wrap gap-2 mt-6">
            {['原创出品', '经典重制', '版权合作', '十二大品类', '1080P高清', '免费观影'].map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 bg-background-100 text-foreground-600 text-xs rounded-full border border-background-200/50 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}